import React, { useState, useCallback } from 'react';
import AccountBalanceDetailDialog from '../Balance/AccountBalanceDetailDialog';

/**
 * Wrapper for AccountBalanceDetailDialog that manages its own state.
 * Usage: Place in parent and call openDialog(accountId, month) to show dialog.
 */
const AccountBalanceDetailDialogWrapper = React.forwardRef(({
  accounts,
  transactions,
  calculateAccountBalanceDetails,
  formatCurrency,
  isForecastMonth
}, ref) => {
  const [open, setOpen] = useState(false);
  const [selectedAccountId, setSelectedAccountId] = useState(null);
  const [selectedAccountMonth, setSelectedAccountMonth] = useState(null);
  const [balanceDetails, setBalanceDetails] = useState(null);

  // Expose openDialog to parent via ref
  React.useImperativeHandle(ref, () => ({
    openDialog: (accountId, month) => {
      setSelectedAccountId(accountId);
      setSelectedAccountMonth(month);
      const details = calculateAccountBalanceDetails(accountId, month);
      setBalanceDetails(details);
      setOpen(true);
    }
  }));

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const account = accounts.find(a => a.id === selectedAccountId);
  const isForecast = isForecastMonth ? isForecastMonth(selectedAccountMonth) : false;

  return (
    <AccountBalanceDetailDialog
      open={open}
      onClose={handleClose}
      accountId={selectedAccountId}
      accountName={account ? account.name : ''}
      month={selectedAccountMonth}
      isForecast={isForecast}
      balanceDetails={balanceDetails}
      transactions={transactions}
      formatCurrency={formatCurrency}
    />
  );
});

export default AccountBalanceDetailDialogWrapper; 